(() => {
  const delay = theme.settings.blurMessageDelay * 1000;
  let timer;
  // The title to put back on focus. Captured when a blur message first
  // replaces the title (not once at load), so a title another script set
  // after load — e.g. product-configurator.js's _updateTitle on a variant
  // change — is what gets restored. null while no blur message is showing.
  let savedTitle = null;

  const nextBlurMessage = (firstMessage) => {
    const message = firstMessage ? theme.settings.blurMessage1 : theme.settings.blurMessage2;
    if (message) {
      if (savedTitle === null) savedTitle = document.title;
      document.title = message;
    }
    if (theme.settings.blurMessage2) {
      timer = setTimeout(() => {
        nextBlurMessage(!firstMessage);
      }, delay);
    }
  };

  window.addEventListener('blur', () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      nextBlurMessage(true);
    }, delay);
  });

  window.addEventListener('focus', () => {
    clearTimeout(timer);
    // Only restore if we replaced the title; otherwise leave whatever is
    // current alone so a short blur/focus never reverts a newer title.
    if (savedTitle !== null) {
      document.title = savedTitle;
      savedTitle = null;
    }
  });
})();
